<script lang="ts">
    import { createEventDispatcher, onDestroy } from "svelte";

    export let time: number = 0;

    const dispatch = createEventDispatcher();

    let isPaused = true;
    let clockInterval: number;
    let timeFormatted: string = '';

    $: formatTime(time);

    onDestroy(pause);

    export function start(): void {
        if (!isPaused) {
            return;
        }
        isPaused = false;
        clockInterval = window.setInterval(clockTick, 1000);
    }

    export function pause(): void {
        isPaused = true;
        window.clearInterval(clockInterval);
    }

    export function getTimeLeft(): number {
        return time;
    }

    function clockTick(): void {
        time = time - 1;
        if (0 === time) {
            pause();
            dispatch('end');
        }
    }

    function formatTime(time: number): void {
        let minutes: number | string = Math.floor(time / 60);
        let seconds: number | string = time % 60;
        if (minutes < 10) minutes = `0${minutes}`;
        if (seconds < 10) seconds = `0${seconds}`;
        timeFormatted = `${minutes}:${seconds}`;
    }

</script>

<style lang="scss">

    .clock {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        color: #fff;
        font-family: 'Grandstander', cursive;
        font-size: 1.6rem;
    }

    img {
        $size: 1.5rem;
        width: $size;
        height: $size;
    }

</style>

<div class="clock">
    <img src="/images/clock.svg" alt="#"> {timeFormatted}
</div>
